import { render } from "./VirtualScene.vue?vue&type=template&id=3b1c2913&ts=true"
import script from "./VirtualScene.vue?vue&type=script&lang=ts"
export * from "./VirtualScene.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__